module.exports = __webpack_public_path__ + "static/media/24_B.041dd37d.png";